module.exports = __webpack_public_path__ + "static/media/microphone.e7bdef88.jpg";